/**
 * The verification-station FieldState's `name` must hold the field's stable
 * IDENTITY, which is `FieldDefinition.internalName` (the `name` column was
 * dropped in the internalName migration). Everything that keys on a field by
 * name — the content-validate bundle lookup (R-239 B3.T2a.2), the cross-field
 * EvalContext — depends on this being the internalName, never undefined.
 *
 * `?? name` is a defensive fallback for any legacy payload still carrying the
 * old column; `?? ""` guarantees a string so a `bundle[name]` lookup is safe.
 */
export function resolveFieldDefinitionName(fd: {
  internalName?: string | null;
  name?: string | null;
}): string {
  return fd.internalName ?? fd.name ?? "";
}
